import type { Component } from 'vue'
import { customIcons } from '../collections/customIcons'
import { heroIcons } from '../collections/heroIcons'
import { lucideIcons } from '../collections/lucideIcons'

const iconMap = {
    ...heroIcons,
    ...lucideIcons,
    ...customIcons,
}

export type IconName = keyof typeof iconMap
export const icons: Record<IconName, Record<'outline' | 'solid' | 'mini' | 'micro', Component>> = iconMap
